import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createElement, useState } from 'react';
import PropTypes from 'prop-types';
import PlusToMinus from '../../../components/icons/PlusToMinus';
import slugify from '../../../utils/strings/slugify';
import css from './index.module.scss';
import CareInstructions from '../Tabs/CareInstructions';
import ChatAndQuestions from '../Tabs/ChatAndQuestions';
import FabricDetails from '../Tabs/FabricDetails';
import FabricLink from '../Tabs/FabricLink';
import HowItFits from '../Tabs/HowItFits';
import Text from '../Tabs/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var COMPONENTS = {
  TEXT: Text,
  FABRIC_DETAILS: FabricDetails,
  FABRIC_LINK: FabricLink,
  CARE_INSTRUCTIONS: CareInstructions,
  HOW_IT_FITS: HowItFits,
  CHAT_AND_QUESTIONS: ChatAndQuestions
};

var Expander = function Expander(_ref) {
  var title = _ref.title,
      index = _ref.index,
      on = _ref.on,
      productKnowledges = _ref.productKnowledges,
      child = _ref.child,
      setIndex = _ref.setIndex;
  var attrs = on ? {} : {
    hidden: 'hidden',
    'aria-expanded': 'false'
  };
  var slug = slugify(title);
  var headerId = "expander-header-".concat(slug);
  var panelId = "expander-panel-".concat(slug);

  var onClick = function onClick() {
    setIndex(on ? -1 : index);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("button", {
      "aria-controls": panelId,
      "aria-expanded": on,
      id: headerId,
      className: css.button,
      onClick: onClick,
      type: "button",
      children: [title, /*#__PURE__*/_jsx(PlusToMinus, {
        open: on
      })]
    }), /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, attrs), {}, {
      id: panelId,
      "aria-labelledby": headerId,
      children: [productKnowledges && productKnowledges.map(function (_ref2) {
        var id = _ref2.id,
            title = _ref2.title,
            description = _ref2.description,
            type = _ref2.type;
        return /*#__PURE__*/createElement(COMPONENTS[type], {
          key: id,
          title: title,
          description: description
        });
      }), child && child]
    }))]
  });
};

Expander.propTypes = {
  child: PropTypes.node,
  productKnowledges: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number,
  on: PropTypes.bool,
  setIndex: PropTypes.func,
  title: PropTypes.string
};

var ExpandCollapse = function ExpandCollapse(_ref3) {
  var productKnowledgeSet = _ref3.productKnowledgeSet;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: productKnowledgeSet.map(function (productKnowledges, idx) {
      return /*#__PURE__*/_createElement(Expander, _objectSpread(_objectSpread({}, productKnowledges), {}, {
        key: productKnowledges.title,
        index: idx,
        on: idx === index,
        setIndex: setIndex
      }));
    })
  });
};

ExpandCollapse.propTypes = {
  productKnowledgeSet: PropTypes.arrayOf(PropTypes.shape({}))
};
export default ExpandCollapse;